import React from 'react';
import PropTypes from 'prop-types';

import getTimestamp from 'utils/getTimestamp';

import { getCalendarDescription } from 'components/Booking-new/utils/steps/summary';
import AddToCalendar from './AddToCalendar';

const CalendarButton = ({ userData, serviceName, type, label, testAttributes }) => {
  const { stepLocationData, stepSummary } = userData;
  const date = stepSummary?.sdate;
  const time = stepSummary?.stime;
  const timeEnd = stepSummary?.stimeend;
  const fullTimeStart = getTimestamp(date, time);
  const fullTimeEnd = getTimestamp(date, timeEnd);

  const heading = stepLocationData?.heading || 'Event title';
  const address = stepLocationData?.address || '';
  const phoneNumber = stepLocationData?.phoneNumber || '';
  const description = getCalendarDescription(type, {
    heading,
    address,
    phoneNumber,
    serviceName,
  });

  return (
    <div data-test={testAttributes}>
      {time && (
        <AddToCalendar
          event={{
            title: heading,
            description: description,
            location: address,
            startTime: fullTimeStart,
            endTime: fullTimeEnd,
          }}
          label={label}
          type={type}
        />
      )}
    </div>
  );
};

CalendarButton.propTypes = {
  label: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,

  testAttributes: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['google', 'default']).isRequired,
  userData: PropTypes.shape({
    stepLocationData: PropTypes.shape({
      address: PropTypes.string,
      heading: PropTypes.string,
      phoneNumber: PropTypes.string,
    }).isRequired,
    stepSummary: PropTypes.shape({
      sdate: PropTypes.string,
      stime: PropTypes.string,
      stimeend: PropTypes.string,
    }).isRequired,
  }),
};

export default CalendarButton;
